import React, { useEffect, useRef, useState } from 'react'
import Header from '../Header/Header';
import Sidebar from '../../pages/Sidebar';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import PhoneInput from "react-phone-input-2";
import Cookies from "js-cookie";
import './AddAreaExecutive.scss';
import { Image_Url } from '../../constants/imageUrl/ImageUrl';
import Validation from '../../constants/validation/Validation';
import { getStateAction } from '../../actions/permissionAction';
import { createAreaExecutiveAction, getAreaExecutiveDetailAction, updateAreaExecutiveAction } from '../../actions/areaExecutiveAction';
import { HTTP_STATUS } from '../../constants/httpstatus/HttpsStatus';
import { NotificationManager } from 'react-notifications';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { hasPermission } from '../../utils/permissionUtils';
import { PERMISSIONS } from '../../constants/permissions/Permissions';
import {
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
  Button,
} from '@mui/material';

const AddAreaExecutive = () => {

  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");
  const dispatch = useDispatch()
  const location = useLocation();
  const { areaExecutiveId } = useParams();
  const { roles = [] } = location.state || {};
  const isEditMode = !!areaExecutiveId;
  const countryPhoneCode = localStorage.getItem('countryPhoneCode')
  const countryPhoneLength = localStorage.getItem('countryPhoneLength')
  const countryMinPhoneLength = localStorage.getItem('countryMinPhoneLength')
  const countryDomain = localStorage.getItem('countryCode');
  const { states } = useSelector((state) => state.getStatesReducer);
  const [selectedStates, setSelectedStates] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [reportsTo, setReportsTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile_number: '',
    reports_to: null,
    state_ids: []
  });

  const { areaExecutiveDetails, loading } = useSelector((state) => state.getAreaExecutiveDetailReducer);

  useEffect(() => {
    if (isEditMode) {
      dispatch(getAreaExecutiveDetailAction(areaExecutiveId));
    }
  }, [dispatch, isEditMode, areaExecutiveId]);

  useEffect(() => {
    if (isEditMode && areaExecutiveDetails) {
      setFormData({
        name: areaExecutiveDetails?.name || '',
        email: areaExecutiveDetails?.email || '',
        reports_to: areaExecutiveDetails?.reports_to?.id || null,
        state_ids: areaExecutiveDetails?.states?.map(state => state.id) || [],
      });
      setPhoneNumber(areaExecutiveDetails?.mobile_number || '');
      setReportsTo(areaExecutiveDetails?.reports_to?.id || null);
      setSelectedStates(areaExecutiveDetails?.states?.map(state => state.id) || []);
    }
  }, [isEditMode, areaExecutiveDetails]);

  useEffect(() => {
    handleChangeLanguage(language);
  }, []);

  useEffect(() => {
    if (reportsTo) {
      dispatch(getStateAction(reportsTo));
    }
  }, [reportsTo]);

  const validateAlphabets = (value) => {
    const regex = /^[\p{L}\s]*$/u;
    return regex.test(value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'name' || name === 'state') {
      if (!validateAlphabets(value)) {
        return;
      }
    }
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const handleSubmitAreaExecutive = async () => {
    if (isLoading) return;

    setIsLoading(true);
    const payload = {
      ...formData,
    };

    let response;

    if (isEditMode) {
      response = await dispatch(updateAreaExecutiveAction(areaExecutiveId, payload))
    }
    else {
      response = await dispatch(createAreaExecutiveAction(payload));

    }
    const { status, message } = response;

    if (status === HTTP_STATUS?.CREATED || status === HTTP_STATUS.SUCCESS) {
      NotificationManager.success(message);
      navigate('/roles_and_permission', { state: { activeComponent: 'areaExecutive' } });
    } else {
      NotificationManager.error(message || t('common.somethingWentWrong'));
    }
    setIsLoading(false);
  }

  const isFormValid = () => {
    return Object.values(formData).every(field =>
      field !== null && field !== undefined && String(field).trim() !== ''
    ) && reportsTo !== null && selectedStates?.length > 0 && phoneNumber?.length >= countryMinPhoneLength;
  };

  const handlePhoneNumberChange = (e) => {
    const phoneValue = e.target.value.replace(/\D/g, '');
    setPhoneNumber(phoneValue);
    setFormData({
      ...formData,
      mobile_number: phoneValue
    });
  };

  const handleReportsChange = (id) => {
    const selectedId = id ? parseInt(id) : null;
    setReportsTo(selectedId);
    setSelectedStates([]);
    setFormData({
      ...formData,
      reports_to: selectedId,
      state_ids: []
    });
  };

  const handleStateChange = (event) => {
    const selectedOptions = event.target.value;

    if (selectedOptions.includes("all")) {
      if (selectedStates?.length === states?.length) {
        setSelectedStates([]);
        setFormData({
          ...formData,
          state_ids: []
        });
      } else if (states?.length > 0) {
        const allStateIds = states?.map(state => state?.id);
        setSelectedStates(allStateIds);
        setFormData({
          ...formData,
          state_ids: allStateIds
        });
      }
    } else {
      setSelectedStates(selectedOptions);
      setFormData({
        ...formData,
        state_ids: selectedOptions
      });
    }
  };

  return (
    <div className='area-executive-containers'>
      <div className='area-executive-main'>
        <div className='area-executive'>
          <div className="header-navigation">
            <p className="area-executive-text">TVS &gt; {t('areaExecutive.areaexecutive')}</p>
          </div>
          <h3 className='area-executive-heading'>
            {isEditMode ? t('areaExecutive.editAreaExecutive') : t('areaExecutive.addAreaExecutive')}
          </h3>
          <div className='area-executive-section'>
            <div className='area-executive-profile'>
              <div className='profile-info'>
                <div className='profile-input'>
                  <div className="input-fields">
                    <label className='required'>{t('common.nameLabel')}</label>
                    <input
                      type='text'
                      placeholder={t('common.namePlaceholder')}
                      name='name'
                      value={formData?.name}
                      onChange={handleInputChange} />
                  </div>
                  <div class="input-fields">
                    <label className='required'>{t('common.emailIdLabel')}</label>
                    <input
                      type='email'
                      placeholder={t('common.emailPlaceholder')}
                      name='email'
                      value={formData?.email}
                      onChange={handleInputChange} />
                  </div>
                  <div class="input-fields">
                    <label className="phone_label required" for="search">
                      {t('addpartner.phoneNumberLabel')}
                    </label>
                    <div className="phone_input">
                      <PhoneInput
                        country={countryDomain}
                        value={countryPhoneCode}
                        disableDropdown={true}
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                      <span className="phone_bar">|</span>
                      <input
                        className="number_inp"
                        maxLength={countryPhoneLength}
                        type="text"
                        name='mobile_number'
                        value={phoneNumber}
                        onKeyPress={(e) => Validation.numberinputValidator(e)}
                        onChange={handlePhoneNumberChange}
                        readOnly={isEditMode}
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                  </div>
                  <div className='input-fields'>
                    <label className='required'>{t('RolesAndPermission.reportsTo')}</label>
                    <select
                      value={reportsTo || ''}
                      onChange={(e) => handleReportsChange(e.target.value)}
                      className="report-dropdown-select"
                    >
                      <option value="" disabled>{t('userManagement.selectRole')}</option>
                      {roles && roles?.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.role}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="input-fields">
                    <label className='required'>{t('common.provinceState')}</label>
                    <FormControl className="multiselect_part">
                      <Select
                        className="multipleSelect_part"
                        labelId="state-label"
                        id="state-select"
                        name="state"
                        multiple
                        displayEmpty
                        inputProps={{ className: 'multiselect_input' }}
                        value={selectedStates}
                        onChange={handleStateChange}
                        renderValue={(selected) =>
                          selected?.length === 0
                            ? <span>{t('RolesAndPermission.selectState')}</span>
                            : selected
                              .map((stateId) => states?.find((s) => s?.id === stateId)?.name)
                              .filter(Boolean)
                              .join(', ')
                        }
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: '200px',
                            },
                          },
                        }}
                      >
                        {states?.length > 0 && (
                          <MenuItem className="partlist_menu" key="all" value="all">
                            <Checkbox checked={selectedStates?.length === states?.length && states?.length > 0} />
                            <ListItemText primary={t('common.selectAll')} />
                          </MenuItem>
                        )}
                        {states?.map((state) => (
                          <MenuItem className="partlist_menu" key={state?.id} value={state?.id}>
                            <Checkbox checked={selectedStates.includes(state?.id)} />
                            <ListItemText primary={state?.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className='cancel-submit-btn'>
                <button
                  className='cancel-btn'
                  onClick={() => navigate('/roles_and_permission', { state: { activeComponent: 'areaExecutive' } })}>
                  {t('common.cancel')}
                </button>
                {hasPermission(PERMISSIONS.CAN_UPDATE_AREA_EXECUTIVE) && (
                  <button
                    className='submit-btn'
                    disabled={!isFormValid() || isLoading}
                    onClick={handleSubmitAreaExecutive}>
                    {isLoading ? <span className="loader-btn"></span> : (isEditMode ? t('common.update') : t('common.submit'))}
                  </button>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default AddAreaExecutive